import { sendEmail } from '../../../../helpers/sendEmail'

import { useState, useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { setResultObject } from '../../../../store/reducers/FormReducer'

import { useNavigate } from 'react-router-dom'

export const useTimer = (input, inputs, analysis, sendInfo) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const sendWithoutChecking = useCallback(() => {
        const { testName } = sendInfo || {}

        return async () => {
            const resultObject = analysis(inputs)
            dispatch(setResultObject(resultObject))

            // extract FIO from inputs similar to useSendButton
            let fio = ''
            const fioInput = inputs.find(
                (input) => (input.type === 'bottomInput' && (input.text?.toLowerCase().includes('фио') || input.id === 0))
            )
            if (fioInput && fioInput.value) {
                fio = fioInput.value
            }

            try {
                const directusSendInfo = {
                    provider: 'directus_flow',
                    baseUrl: 'https://crm-hr.kzn.ru',
                    flowId: '9c0df71d-3ceb-4ab4-aa0c-a6806f3d89a6',
                    token: 'sGaLAYCUxT_HpfAaMiQNb4qzieuAtUAM',
                    subjectPrefix: process.env.REACT_APP_DIRECTUS_SUBJECT_PREFIX || 'HR Tests',
                }
                await sendEmail(undefined, testName || '', fio, resultObject.result, undefined, directusSendInfo)
            } catch (error) {
                console.log(error)
            }

            navigate('/finish')
        }
    }, [inputs])

    const send = sendWithoutChecking()

    const [[hours, minutes, seconds], setTimer] = useState([input.hours, input.minutes, input.seconds])

    const tick = () => {
        if (hours === 0 && minutes === 0 && seconds === 0) {
            send()
        } else if (minutes === 0 && seconds === 0) {
            setTimer([hours - 1, 59, 59])
        } else if (seconds === 0) {
            setTimer([hours, minutes - 1, 59])
        } else {
            setTimer([hours, minutes, seconds - 1])
        }
    }

    return {
        hours,
        minutes,
        seconds,
        tick,
    }
}